import React from 'react';
import './MetadataContentWrapper.scss';
import classNames from 'classnames';

export interface MetadataContentWrapperProps {
  /**  Any React.ReactNode component. Make sure there is no wrapper around the children. */
  children: React.ReactNode;
  /** Size of the container, applies the appropriate gap. default medium. */
  size?: 'small' | 'medium' | 'large';
  /** Alignment of the content. Default is 'left'. */
  align?: 'left' | 'center' | 'right';
  /** Additional class names */
  className?: string;
}

/**
 * MetadataContentWrapper Component - A flex wrapper that applies flex gap and alignment to metadata content.
 * @param align - Alignment of the content. Default is 'left'.
 * @param size - Size of the container, applies the appropriate gap. default medium.
 * @param children - Any React.ReactNode component. Make sure there is no wrapper around the children.
 */
export const MetadataContentWrapper: React.FC<MetadataContentWrapperProps> = ({
  children,
  size = 'medium',
  align = 'left',
  className,
}) => {
  return (
    <div
      className={classNames(
        'vds-metadata-content',
        `vds-metadata-content--${size}`,
        `vds-metadata-content--${align}`,
        className,
      )}>
      {children}
    </div>
  );
};
